export enum TournamentSystemName {
  Euro24 = 'euro',
  UefaCL2425Group = 'uefa',
  UefaCL2425PlayOff = 'uefa_playoff',
  Ufc = 'ufc',
}
